import React, { useState, useEffect } from "react";
import { Form, Card, Button, Typography, message, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";

import {
  SUPPLIER_STATUS,
  ERROR_MESSAGES,
  TEXTS,
  SUPPLIER_DETAILS_CONSTANTS,
  AlertMessages,
} from "../../constants/Constants";
import {
  fetchSuppliers,
  submitSupplierData,
  updateContactDetails,
  updateAssociatedSuppliers,
} from "../../redux/slices/supplierFormSlice";
import { EditOutlined, DeleteOutlined, UserOutlined } from "@ant-design/icons";
import SupplierDetails from "../../components/signup/SupplierDetails";
import ContactDetails from "../../components/signup/ContactDetails";
import AdditionalDetails from "../../components/signup/AdditionalDetails";
import "../Supplier/SupplierForm.css";
import ConfirmationModalBox from "../../components/common/ConfirmationModelBox/ConfirmationModelBox";
import {
  setCompanyName,
  setAddressLine1,
  setAddressLine2,
  setSupplierType,
  setCountry,
  setState,
  setZipCode,
  setFirstName,
  setLastName,
  setUserId,
  setEmailId,
  setPhoneNumber,
  setUserType,
  setDesignation,
  setAdditionalDetails,
  setAdditionalDetail,
  removeAdditionalSupplier,
  resetAdditionalDetails,
  updateAdditionalDetails,
  populateUserData,
  setExistingSupplier,
  setIsUser,
  setIsExistingCompany,
} from "../../redux/slices/signupSlice";
import SupplierProfile from "../../components/signup/SupplierProfile";
import { getUserById, signupApiService } from "../../services/signupService";
import { Navigate, useNavigate } from "react-router-dom";
import { set } from "lodash";
import Loader from "../../components/common/Loader/Loader";

const { Title } = Typography;

const SupplierForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [supplierInfo, setSupplierInfo] = useState(null);
  const [contactInfo, setContactInfo] = useState(null);
  const [additionalInfo, setAdditionalInfo] = useState([]);
  const [editing, setEditing] = useState(true);
  const [editIndex, setEditIndex] = useState(null);
  const [currentEditingSupplier, setCurrentEditingSupplier] = useState(null);
  const [nextConfirm, setNextConfirm] = useState(false);
  const dispatch = useDispatch();
  const {
    firstName,
    companyName,
    addressLine1,
    addressLine2,
    supplierType,
    country,
    state,
    zipcode,
    FirstName,
    LastName,
    userId,
    emailId,
    phoneNumber,
    userType,
    designation,
    additionalDetails,
    existingSupplier,
    isUser,
    isExistingCompany,
    isErrorContactDetails,
    isErrorSupplierDetails,
  } = useSelector((state) => state.signup);

  const EmailId = sessionStorage.getItem("Email") || "";

  const supplierId = sessionStorage.getItem("supplierId");
  const ROLE = sessionStorage.getItem("Role");
  const navigate = useNavigate();

  const fetchUserData = async (EmailId) => {
    try {
      const userData = await getUserById(EmailId);
      console.log(EmailId);
      dispatch(populateUserData(userData));
      userData && dispatch(setExistingSupplier(true));
      userData && dispatch(setIsExistingCompany(false));
      if (isUser && userData) {
        setLoading(false);
        setStep(2);
      } else {
        setLoading(false);
        setStep(4);
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
    if (EmailId) {
      setLoading(true);
      fetchUserData(EmailId, supplierId);
    }
  }, [EmailId]);

  useEffect(() => {
    if (existingSupplier) {
      setSupplierInfo({
        companyName: companyName || "",
        addressLine1: addressLine1 || "",
        addressLine2: addressLine2 || "",
        supplierType: supplierType || "",
        country: country || "",
        state: state || "",
        zipcode: zipcode || "",
      });

      setContactInfo({
        firstName: firstName || "",
        lastName: LastName || "",
        userId: userId || "",
        emailId: emailId || "",
        phoneNumber: phoneNumber || "",
        userType: userType || "",
        designation: designation || "",
      });

      setAdditionalInfo(additionalDetails || []);
    }
  }, [existingSupplier]);

  const handleAddSupplierDetails = (details) => {
    message.success("Supplier Details added Sucessfully");
    setSupplierInfo(details);
    setEditing(false);
  };
  const handleAddContactDetails = (details) => {
    setContactInfo(details);
    console.log(details);
    setEditing(false);
    setEditIndex(null);
    setStep(2);
  };

  const handleDeleteContact = () => {
    setContactInfo(null);
    dispatch(setFirstName(""));
    dispatch(setLastName(""));
    dispatch(setUserId(""));
    dispatch(setEmailId(""));
    dispatch(setPhoneNumber(""));
    dispatch(setUserType(undefined));
    dispatch(setDesignation(undefined));
  };

  const handleAddAdditionalDetails = (details) => {
    if (editing && editIndex !== null) {
      const updatedAdditional = [...additionalInfo];
      updatedAdditional[editIndex] = details.associatedSuppliers[0];
      setAdditionalInfo(updatedAdditional);
      dispatch(
        updateAdditionalDetails({
          index: editIndex,
          newValue: updatedAdditional[editIndex],
        })
      );
    } else {
      const newSupplier = details.associatedSuppliers[0];
      const isDuplicate = additionalInfo.some(
        (additional) => additional.supplierId === newSupplier.supplierId
      );

      if (isDuplicate) {
        message.error(AlertMessages.SUPPLIERID_DUPLICATE);
        return;
      }

      setAdditionalInfo([...additionalInfo, newSupplier]);

      const suppliers = details.associatedSuppliers.map((supplier) => ({
        supplierId: supplier.supplierId,
        countryCode: supplier.countryCode,
      }));

      dispatch(setAdditionalDetail(suppliers[0]));
    }

    setEditing(false);
    setEditIndex(null);
    setCurrentEditingSupplier(null);
  };

  const handleDeleteAdditional = (index) => {
    dispatch(removeAdditionalSupplier(index));

    const updatedAdditional = additionalInfo.filter((_, i) => i !== index);
    setAdditionalInfo(updatedAdditional);
  };

  const handlePrevious = (prevStep) => {
    setStep(prevStep);
    setEditing(false);
    setEditIndex(null);
    setCurrentEditingSupplier(null);
  };

  const handleSubmit = () => {
    if (contactInfo === null) {
      message.error(SUPPLIER_DETAILS_CONSTANTS.CONTACTINFO_ERROR);
      return;
    }
    if (additionalInfo.length === 0) {
      message.error(SUPPLIER_DETAILS_CONSTANTS.ADDITIONALINFO_ERROR);
      return;
    }
    const formattedData = {
      companyName: companyName,
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      supplierType: supplierType,
      state: state,
      country: country,
      zipcode: zipcode,
      firstName: FirstName,
      lastName: LastName,
      userId: userId,
      emailId: emailId,
      phoneNumber: phoneNumber,
      role: userType,
      designation: designation,
      associatedSuppliers: additionalDetails,
    };

    Modal.confirm({
      title: EmailId ? TEXTS.CONFIRMUPDATION : TEXTS.CONFIRMSUBMISSION,
      content: EmailId
        ? "Are you sure you want to update this supplier?"
        : TEXTS.CONFIRMCONTENT,
      onOk: async () => {
        try {
          const result = await signupApiService.saveOrUpdateUser(
            formattedData,
            EmailId
          );
          message.success(
            EmailId
              ? "Supplier Data updated successfully!"
              : ERROR_MESSAGES.formSubmissionSuccess
          );
          dispatch(setIsUser(false));
          sessionStorage.setItem("firstName", FirstName);
          sessionStorage.setItem("Role",userType)
          if (EmailId) {
            navigate("/supplier");
          } else {
            navigate("/supplierLogin");
          }
          handleClearData();
        } catch (error) {
          message.error(ERROR_MESSAGES.formSubmissionError(error));
        }
      },
      onCancel() {
        console.log(ERROR_MESSAGES.submissionCancelled);
      },
    });
  };

  const handleEdit = (type, index) => {
    setEditing(true);
    setEditIndex(index);

    if (type === SUPPLIER_DETAILS_CONSTANTS.SUPPLIER_TYPE) {
      setStep(1);
    } else if (type === SUPPLIER_DETAILS_CONSTANTS.CONTACT_TYPE) {
      setStep(2);
    } else if (type === SUPPLIER_DETAILS_CONSTANTS.ADDITIONAL_TYPE) {
      setStep(3);
      const supplierToEdit = additionalInfo[index];
      setCurrentEditingSupplier({
        supplierId: supplierToEdit.supplierId,
        countryCode: supplierToEdit.countryCode,
      });
    }
  };

  const handleClearData = () => {
    // setSupplierInfo(null);
    // setContactInfo([]);
    // setAdditionalInfo([]);
    setEditing(false);
    setEditIndex(null);
    setCurrentEditingSupplier(null);
    // setStep(1);
  };

  const handleClearSupplierData = () => {
    setSupplierInfo(null);
  };
  const handleClearContactDetails = () => {
    setContactInfo(null);
  };

  const handleDeleteSupplierDetails = () => {
    setSupplierInfo(null);
    dispatch(setCompanyName(""));
    dispatch(setAddressLine1(""));
    dispatch(setAddressLine2(""));
    dispatch(setSupplierType(undefined));
    dispatch(setCountry(undefined));
    dispatch(setState(undefined));
    dispatch(setZipCode(""));
  };

  const handleProfileReset = () => {
    if (existingSupplier) {
      navigate("/supplier");
    } else {
      handleDeleteSupplierDetails();
      handleDeleteContact();
      setAdditionalInfo([]);
      dispatch(resetAdditionalDetails());
      setStep(1);
    }
  };

  const handleNextStep = () => {
    if (additionalInfo.length === 0) {
      message.error(SUPPLIER_DETAILS_CONSTANTS.ADDITIONALINFO_ERROR);
      return;
    }
    setStep(4);
  };
  const handleButtonNext = () => {
    message.warning(
      "Please fill the missing field before moving to the other page."
    );
    return;
  };

  return (
    <>
      <div className="flex-grow h-[100vh] bg-gray-100 flex items-center justify-center p-8">
        {loading ? (
          <Loader />
        ) : (
          <Card className="w-full h-full max-w-md shadow-lg rounded-lg overflow-auto text-center">
            <Title level={2}>
              {step === 1
                ? SUPPLIER_DETAILS_CONSTANTS.SUPPLIER_DETAILS
                : step === 2
                ? SUPPLIER_DETAILS_CONSTANTS.CONTACT_DETAILS
                : step === 3
                ? SUPPLIER_DETAILS_CONSTANTS.ADDITIONAL_DETAILS
                : "Supplier Profile"}
            </Title>
            <div className="mb-4" hidden={step === 4 ? true : false}>
              <Button
                type={step === 1 ? "primary" : "default"}
                className="mr-2"
                disabled={isUser || ROLE == "Supplier User"}
                onClick={() => {
                  if (isErrorContactDetails) {
                    handleButtonNext();
                    return;
                  } else {
                    setStep(1);
                    setEditing(false);
                  }
                }}
              >
                1
              </Button>
              <Button
                type={step === 2 ? "primary" : "default"}
                className="mr-2"
                onClick={() => {
                  if (isErrorSupplierDetails) {
                    handleButtonNext();
                    return;
                  } else {
                    contactInfo ? setEditing(false) : setEditing(true);
                    setStep(2);
                  }
                }}
                disabled={isExistingCompany || !supplierInfo}
              >
                2
              </Button>

              <Button
                type={step === 3 ? "primary" : "default"}
                onClick={() => {
                  if (isErrorContactDetails || isErrorSupplierDetails) {
                    handleButtonNext();
                    return;
                  } else {
                    setStep(3);
                    setEditing(false);
                  }
                }}
                disabled={
                  !contactInfo ||
                  isUser ||
                  ROLE == "Supplier User" ||
                  isExistingCompany
                }
              >
                3
              </Button>
            </div>

            {step === 1 && (
              <>
                {!supplierInfo || editing ? (
                  <SupplierDetails
                    onAdd={handleAddSupplierDetails}
                    clearData={handleClearSupplierData}
                  />
                ) : (
                  <div className="flex flex-col items-center gap-4">
                    <div className="flex flex-col items-center gap-4">
                      <div className="flex gap-4 w-[300px]">
                        <div className="flex items-start bg-[#E6F4F1] p-4 rounded-lg w-full">
                          <UserOutlined className="text-4xl mr-4 flex-shrink-0" />
                          <div className="flex-grow min-w-0 text-left">
                            <div className="mb-0 font-bold break-words whitespace-normal">
                              {companyName}
                            </div>
                            <div className="mb-0 break-words whitespace-normal">
                              {addressLine1}, {addressLine2}
                            </div>
                            <div className="mb-0 break-words whitespace-normal">
                              {supplierType}
                            </div>
                            <div className="mb-0 break-words whitespace-normal">
                              {country}, {state}
                            </div>
                            <div className="mb-0 font-bold">{zipcode}</div>
                          </div>
                          <div className="flex flex-col items-center ml-4 flex-shrink-0">
                            <EditOutlined
                              className="text-lg mb-4 hover:text-blue-500 hover:scale-125 transition-all duration-200 cursor-pointer"
                              onClick={() =>
                                handleEdit(
                                  SUPPLIER_DETAILS_CONSTANTS.SUPPLIER_TYPE
                                )
                              }
                            />
                            <DeleteOutlined
                              className="text-lg hover:text-red-500 hover:scale-125 transition-all duration-200 cursor-pointer"
                              onClick={handleDeleteSupplierDetails}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <Button
                      type="primary"
                      onClick={() => {
                        setNextConfirm(true);
                      }}
                      className="w-[20%]"
                    >
                      {SUPPLIER_DETAILS_CONSTANTS.BUTTON_NEXT}
                    </Button>
                    <ConfirmationModalBox
                      visible={nextConfirm}
                      onConfirm={() => {
                        setStep(2);
                        setNextConfirm(false);
                        contactInfo ? setEditing(false) : setEditing(true);
                      }}
                      onCancel={() => {
                        setNextConfirm(false);
                      }}
                      title={"Are you sure you want to move to next tab?"}
                      message={"   "}
                    />
                  </div>
                )}
              </>
            )}

            {step === 2 && (
              <>
                {contactInfo === null || editing ? (
                  <ContactDetails
                    onAdd={handleAddContactDetails}
                    clearData={handleClearContactDetails}
                    initialValues={editing ? contactInfo : {}}
                  />
                ) : (
                  <div className="flex flex-col items-center gap-4 mt-4">
                    <div className="flex gap-4 h-auto w-[300px]">
                      <div className="flex items-center bg-[#E6F4F1] p-4 rounded-lg w-full">
                        <UserOutlined className="text-4xl mr-4" />
                        <div className="flex-grow text-left">
                          <div className="mb-2">
                            <div className="font-bold">
                              {FirstName} {LastName}
                            </div>
                            <div>{emailId}</div>
                            <div>{userType}</div>
                            <div className="font-bold">{designation}</div>
                          </div>
                        </div>
                        <div className="flex flex-col items-center ml-4">
                          <EditOutlined
                            className="text-lg mb-8 hover:text-blue-500 hover:scale-125 transition-all duration-200 cursor-pointer"
                            onClick={() =>
                              handleEdit(
                                SUPPLIER_DETAILS_CONSTANTS.CONTACT_TYPE
                              )
                            }
                          />
                          <DeleteOutlined
                            className="text-lg mt-4 hover:text-red-500 hover:scale-125 transition-all duration-200 cursor-pointer"
                            onClick={handleDeleteContact}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <br />

                {!editing && (
                  <>
                    <Button
                      onClick={() => handlePrevious(1)}
                      className="mr-[8px] w-[20%]"
                      disabled={isUser || ROLE == "Supplier User"}
                    >
                      {SUPPLIER_DETAILS_CONSTANTS.BUTTON_PREVIOUS}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => setNextConfirm(true)}
                      className="w-[20%]"
                    >
                      {SUPPLIER_DETAILS_CONSTANTS.BUTTON_NEXT}
                    </Button>
                    <ConfirmationModalBox
                      visible={nextConfirm}
                      onConfirm={() => {
                        if (isUser || ROLE == "Supplier User") {
                          setStep(4);
                          return;
                        }
                        setStep(3);
                        setNextConfirm(false);
                      }}
                      onCancel={() => {
                        setNextConfirm(false);
                      }}
                      title={"Are you sure you want to move to the next tab?"}
                      message={"   "}
                    />
                  </>
                )}
              </>
            )}

            {step === 3 && (
              <>
                <div className="flex flex-col items-center gap-4 mt-4">
                  {additionalInfo?.map((additional, index) => (
                    <div
                      key={index}
                      className="flex gap-4 h-auto w-full max-w-[300px]"
                    >
                      <div className="flex items-start bg-[#E6F4F1] p-4 rounded-lg w-full">
                        <UserOutlined className="text-4xl mr-4 flex-shrink-0" />
                        <div className="flex-grow min-w-0 text-left">
                          <div className="mb-2 break-words whitespace-normal">
                            <div className="font-bold">
                              {SUPPLIER_DETAILS_CONSTANTS.SUPPLIER_ID}:{" "}
                              {additional.supplierId}
                            </div>
                            <div>
                              {SUPPLIER_DETAILS_CONSTANTS.COUNTRY_CODE}:{" "}
                              {additional.countryCode}
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-col items-center ml-4 flex-shrink-0">
                          <EditOutlined
                            className="text-2xl mb-4 cursor-pointer hover:text-blue-500 hover:scale-125 transition-all duration-200"
                            onClick={() =>
                              handleEdit(
                                SUPPLIER_DETAILS_CONSTANTS.ADDITIONAL_TYPE,
                                index
                              )
                            }
                          />
                          <DeleteOutlined
                            className="text-2xl cursor-pointer hover:text-red-500 hover:scale-125 transition-all duration-200"
                            onClick={() => {
                              handleDeleteAdditional(index);
                              console.log(index);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <AdditionalDetails
                  onAdd={handleAddAdditionalDetails}
                  initialValues={currentEditingSupplier}
                  currentValue={additionalInfo}
                />
                <br />
                <Button
                  onClick={() => handlePrevious(2)}
                  className="mr-[8px] w-[20%]"
                >
                  {SUPPLIER_DETAILS_CONSTANTS.BUTTON_PREVIOUS}
                </Button>
                <Button
                  type="primary"
                  onClick={handleNextStep}
                  className="w-[20%]"
                >
                  {SUPPLIER_DETAILS_CONSTANTS.BUTTON_NEXT}
                </Button>
              </>
            )}

            {step === 4 && (
              <>
                <SupplierProfile
                  setStep={setStep}
                  setEditing={setEditing}
                  handleEdit={handleEdit}
                />
                <div className="mt-5 flex flex-col">
                  <Button
                    type="primary"
                    onClick={handleSubmit}
                    className="mb-5"
                  >
                    {existingSupplier ? "Update User" : "Create User"}
                  </Button>
                  <Button onClick={handleProfileReset}>
                    {existingSupplier ? "Back Home" : "Cancel"}
                  </Button>
                </div>
              </>
            )}
          </Card>
        )}
      </div>
    </>
  );
};

export default SupplierForm;
